var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (value) {if (value) {
if (value.isBudgetCenterEntryEnabled) {
pug_html = pug_html + "\u003Cspan class=\"performance-metrics-value\"\u003E\u003Cspan class=\"budget-center-entry\" tabindex=\"0\" role=\"button\"\u003E" + (pug.escape(null == (pug_interp = value.metricValue) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"performance-metrics-value\"\u003E";
if (value.hasConversionDeliveryStatus) {
pug_html = pug_html + "\u003Cspan class=\"status-column status-warning conversion-warning-delivery-status\"\u003E\u003Cspan class=\"status-icon iconba iconba-Warning\"\u003E&nbsp;\u003C\u002Fspan\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = value.metricValue) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = value.metricValue) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"performance-metrics-fluctuation\"\u003E";
if (value.hasFluctuation) {
pug_html = pug_html + "\u003Cspan" + (" class=\"iconba iconba-Insights clickable\""+" tabindex=\"0\" role=\"button\""+pug.attr("data-metric-name", value.metricName, true, true)+pug.attr("data-metric-value", value.metricValue, true, true)+pug.attr("data-metric-type", value.metricType, true, true)) + "\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = '-') ? "" : pug_interp));
}}.call(this,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return pug_html;};
module.exports = template;